import { render, staticRenderFns } from "./UkrposhtaProduct.vue?vue&type=template&id=6cecb066&scoped=true"
import script from "./UkrposhtaProduct.vue?vue&type=script&lang=js"
export * from "./UkrposhtaProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cecb066",
  null
  
)

export default component.exports